<template>
    <v-dialog v-model="dialog" max-width="560" persistent scrollable>
        <v-card>
            <v-card-title class="d-flex align-center pa-4">
                <v-icon icon="mdi-menu" class="mr-2" color="primary" />
                Menu di
                <span class="font-weight-bold ml-1">{{ nomeUtente }}</span>
                <v-spacer />
                <v-btn icon="mdi-close" variant="text" @click="chiudi" />
            </v-card-title>

            <v-divider />

            <!-- Stato caricamento -->
            <v-card-text v-if="loading" class="d-flex justify-center align-center pa-8">
                <v-progress-circular indeterminate color="primary" />
            </v-card-text>

            <v-card-text v-else class="pa-0" style="max-height: 440px;">
                <v-alert type="info" variant="tonal" density="compact" class="ma-3"
                    text="Deseleziona le voci per nasconderle all'utente. Le voci disabilitate non vengono ereditate dal ruolo." />

                <!-- Menu radice (senza parent) -->
                <template v-for="voce in vociRadice" :key="voce.menuID">
                    <v-list-item :class="['px-4', !voce.visible ? 'bg-grey-lighten-4' : '']">
                        <template #prepend>
                            <v-icon :icon="voce.img || 'mdi-circle-small'" size="20"
                                :color="voce.visible ? 'primary' : 'grey'" class="mr-2" />
                        </template>
                        <v-list-item-title :class="voce.visible ? '' : 'text-grey text-decoration-line-through'">
                            {{ voce.text }}
                        </v-list-item-title>
                        <template #append>
                            <v-switch v-model="voce.visible" color="primary" density="compact" hide-details
                                @change="onCambioVisibilita(voce)" />
                        </template>
                    </v-list-item>

                    <!-- Figli -->
                    <template v-for="figlio in getFigli(voce.menuID)" :key="figlio.menuID">
                        <v-list-item :class="['pl-10 pr-4', !figlio.visible ? 'bg-grey-lighten-4' : '']">
                            <template #prepend>
                                <v-icon :icon="figlio.img || 'mdi-minus'" size="16"
                                    :color="figlio.visible ? 'secondary' : 'grey-lighten-1'" class="mr-2" />
                            </template>
                            <v-list-item-title class="text-body-2"
                                :class="figlio.visible ? '' : 'text-grey text-decoration-line-through'">
                                {{ figlio.text }}
                            </v-list-item-title>
                            <template #append>
                                <v-switch v-model="figlio.visible" color="secondary" density="compact" hide-details
                                    :disabled="!voce.visible" @change="onCambioVisibilita(figlio)" />
                            </template>
                        </v-list-item>
                    </template>

                    <v-divider />
                </template>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-4">
                <v-btn variant="text" prepend-icon="mdi-restore" @click="ripristinaDefault">
                    Ripristina default
                </v-btn>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" variant="elevated" :loading="salvando" @click="salva">
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { get_menu_utente, aggiorna_menu_utente } from '@/api/api.amministrazione'

export default {
    name: 'DialogoMenu',

    emits: ['salvato'],

    data() {
        return {
            dialog: false,
            loading: false,
            salvando: false,
            utenteId: null,
            nomeUtente: '',
            menu: [],
            menuOriginale: [],
        }
    },

    computed: {
        vociRadice() {
            return this.menu
                .filter(v => !v.parentID)
                .sort((a, b) => a.progOrder - b.progOrder)
        }
    },

    methods: {
        getFigli(parentId) {
            return this.menu
                .filter(v => v.parentID === parentId)
                .sort((a, b) => a.progOrder - b.progOrder)
        },

        async apri(utente) {
            this.utenteId = utente.userID
            this.nomeUtente = utente.userName
            this.menu = []
            this.dialog = true
            this.loading = true
            try {
                const { data } = await get_menu_utente(utente.userID)
                this.menu = data.map(v => ({ ...v }))
                this.menuOriginale = data.map(v => ({ ...v }))
            } finally {
                this.loading = false
            }
        },

        chiudi() {
            this.dialog = false
        },

        onCambioVisibilita(voce) {
            // Se si nasconde un genitore, nascondi anche tutti i figli
            if (!voce.visible) {
                this.menu
                    .filter(f => f.parentID === voce.menuID)
                    .forEach(f => { f.visible = false })
            }
        },

        ripristinaDefault() {
            this.menu = this.menuOriginale.map(v => ({ ...v, visible: true }))
        },

        async salva() {
            this.salvando = true
            try {
                const payload = this.menu.map(v => ({
                    menuID: v.menuID,
                    visible: v.visible
                }))
                await aggiorna_menu_utente(this.utenteId, payload)
                this.$emit('salvato')
                this.chiudi()
            } finally {
                this.salvando = false
            }
        }
    }
}
</script>